import { IHiddenRanges } from 'src/interfaces/global';
import NGSpinner from 'src/styles/theme/components/NGSpinner';
import NGText from 'src/styles/theme/components/NGText';
import { EMediaQuery, ESize, EThemeColor } from 'src/styles/theme/utils/enums';
import {
	addFramesStyles,
	addHiddenRangesStyles,
	addMarginStyles,
	addPaddingStyles,
	addTransition,
	getThemeColor,
	mq
} from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';

export const NGTextEx = styled(NGText)<{ isActivated?: boolean }>`
	${(p) => css`
		height: 20px;
		width: 20px;

		padding-top: 2px;

		border-radius: 50%;
		background-color: ${p.theme.colors.gold};

		overflow: hidden;

		text-align: center;

		${addTransition()}

		${p.isActivated
			? `
		margin-left: 20px;
		opacity: 1;
		max-width: 50px;
		`
			: `
			margin-left: 0px;
			opacity: 0;
			max-width: 0px;
			`}
	`}
`;

export const StyledButton = styled.button<
	{
		size?: ESize;
		fullWidth?: boolean;
		colorVariant?: EThemeColor;
		isHidden?: boolean;
		secondary?: boolean;
	} & IHiddenRanges
>`
	${(p) => css`
			position: relative;
			z-index: 2;

			padding: 0;

			border-radius: 5px;
			border: solid 1px;

			background-color: ${p.theme.colors.carbon};

			${addTransition()}

			${!p.disabled && !p.isHidden ? `cursor: pointer;` : 'pointer-events: none;'}
			${p.fullWidth ? `width: 100%;` : ''}
      ${p.isHidden ? `opacity: 0;` : ''}

				${() => {
					switch (p.size) {
						case ESize.xs:
							return `
						padding: 12px 24px;
						${mq(EMediaQuery.md, 'padding: 12px 24px;')}
					`;
						case ESize.s:
							return `
						padding: 6px 24px;
						${mq(EMediaQuery.md, 'padding: 12px 24px;')}
					`;
						default: // includes ESize.m
							return `
						padding: 8px 24px;
						${mq(EMediaQuery.md, 'padding: 12px 24px;')}
					`;
					}
				}}

				${addPaddingStyles(p)}
				${addMarginStyles(p)}
				${addFramesStyles(p)}
				${addHiddenRangesStyles(p)}

				border-color: ${getThemeColor(p.theme, p.colorVariant || EThemeColor.gold)}80;

				${
					!p.secondary
						? css`
								text-align: center;
								display: flex;
								align-items: center;
								justify-content: center;

								${!p.disabled
									? `
									@media (hover: hover) {
										&:hover > span:not(${NGTextEx}),
										&:hover > span:not(${NGTextEx}) > span {
											color: ${getThemeColor(p.theme, p.colorVariant || EThemeColor.gold)};
										}
									}
									`
									: ''}
						  `
						: css`
								display: flex;
								justify-content: center;
								align-items: center;

								border-left: none;
								border-bottom: none;
								border-radius: 1px;

								background-color: transparent;

								border-top: 1px solid ${p.theme.colors.lead};
								border-right: 1px solid ${p.theme.colors.lead};
						  `
				}
			}

			${
				!p.disabled
					? css`
							@media (hover: hover) {
								&:hover {
									color: ${getThemeColor(p.theme, p.colorVariant || EThemeColor.gold)};
								}
							}

							&:active {
								transform: scale(0.95);
							}
					  `
					: !p.isHidden
					? 'opacity: 0.5;'
					: ''
			}
		`}
`;

export const NGSpinnerEx = styled(NGSpinner)`
	right: 0;
`;
